import { render, staticRenderFns } from "./loArticle.vue?vue&type=template&id=2473a2f5&scoped=true&"
import script from "./loArticle.vue?vue&type=script&lang=js&"
export * from "./loArticle.vue?vue&type=script&lang=js&"
import style0 from "./loArticle.vue?vue&type=style&index=0&id=2473a2f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473a2f5",
  null
  
)

export default component.exports